import React from "react";
import { useFooterHook } from "./Hooks";
import { useNavigation } from "../Nav/Hooks";
import { FooterContentPiece, FooterProps } from "./Pieces";
export default function FooterComponent(props: FooterProps) {
  const { footerData } = useFooterHook();
  const navigation = useNavigation();
  return (
    <FooterContentPiece
      {...props}
      footerData={footerData}
      navigation={navigation}
    />
  );
}
